export const EncourageBePartSidr = [
    {
        imageUrl: '/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_entrepreneurship.webp',
        imageAltText: 'sidr entrepreneurship',
        title: 'entrepreneurship',
        description: 'We encourage an entrepreneurial mindset, where our employees persevere to overcome challenges to be a key element of the SIDR’s success.',
        width: '143.68px',
        height: '221.84px'
    }, {
        imageUrl: '/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_diversity.webp',
        imageAltText: 'sidr diversity',
        title: 'diversity',
        description: 'We embrace diversity, in our portfolio, our workforce, and in markets we serve as a driver of sustainable success.',
        width: '290px',
        height: '277px'
    }, {
        imageUrl: '/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_leadership.webp',
        imageAltText: 'sidr leadership',
        title: 'leadership',
        description: 'We inspire our employees to reach their full potential in an environment that encourages creativity, knowledge sharing and mutual development, and development opportunities that help shape responsible corporate citizens and future leaders.',
        width: '337.37px',
        height: '190.57px'
    }, {
        imageUrl: '/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_integrity.webp',
        imageAltText: 'sidr integrity',
        title: 'integrity',
        description: 'We adhere to the highest standards of ethical business practices and our impeccable and extensive track record is testament to this commitment.',
        width: '175.54px',
        height: '240.7px'
    }, {
        imageUrl: '/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_unity.webp',
        imageAltText: 'sidr unity',
        title: 'unity',
        description: 'We are united by a shared vision and work together as one team to deliver stakeholder value.',
        width: '227.62px',
        height: '184.94px'
    },
]

export const ImageGallery = [
    {
        imageUrl: '/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_1.webp',
        imageAltText: 'sidr dinner fun',
    }, {
        imageUrl: '/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_2.webp',
        imageAltText: 'sidr health',
    }, {
        imageUrl: '/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_3.webp',
        imageAltText: 'sidr love',
    }, {
        imageUrl: '/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_4.webp',
        imageAltText: 'sidr activity',
    },
]
